import './LoadServicesContainer.scss';
import '../../../../Shared/BookNowTable/BookNowTable.scss';

type TLoadServicesContainerProps = {
  services: any[];
  tableTitle: string;
};

const LoadServicesContainer = (props: TLoadServicesContainerProps) => {
  return (
    <div className="Book_Table">
      <div className="Table_Header">
        <span>Services Details</span>
      </div>
      <div className="Table_Container">
        <div className="Table_Body">
          {props.services.length > 0 ? (
            props.services.map((item: any) => (
              <div className="TableRow_Services">
                <p>{item}</p>
              </div>
            ))
          ) : (
            <div data-testid="NoData" className="No_Data">
              No data available.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LoadServicesContainer;
